// SAMPLE:
//     <ehc-main-menu-edit  
//       @close="sectionPopup = !sectionPopup" 
//       :fields="cardItemsForLabelEdit" 
//       :cardItemsForFormData="cardItemsForFormData" 
//       type="propertyinfo"/>

<template>  
    <ehc-form v-model="formData" :meta="meta" @submit="update" class="mt-7">
    </ehc-form>
</template>

<script>
export default {
  props: {
    fields: {
      required: true,
      type: Array,
    },  // fields to edit 
    cardItemsForFormData: {
      required: true,
        // type: Array, Caused console error - Invalid prop: type check failed for prop "cardItemsForFormData". Expected Array, got Object
    },  // card items to edit
  },
  data(){
    return {
        loading: false,
        formData: {},
      }
    },
  computed: {
    meta: function() {
      return this.fields.concat([
        {
          type: "submit",
          label: "Update",
          emitOnClick: "update",
          loading: this.loading
        },
      ])
    } 
  },
  watch: {
    cardItemsForFormData: function(val){
      this.formData = val
    }
  },
  methods: {
    update(){
      const formData = this.formData || {}
      // Build new objects (do not mutate Vuex state in place) so the home
      // menu recomputes immediately after save.
      const sourceItems = this.$store.state.cardItems && this.$store.state.cardItems.length
        ? this.$store.state.cardItems
        : this.$store.getters.cardItems
      const newCardItems = sourceItems.map((el) => {
        const nextLabel = formData[el.id]
        if (nextLabel == null || nextLabel === "") {
          return { ...el }
        }
        return {
          ...el,
          label: nextLabel,
          pageTitle: nextLabel,
        }
      })
      this.$store.dispatch("updateCustomCardItems", {
        cardItems: newCardItems,
        propertyId: this.$store.getters.propertyId,
      })
      this.close()
    },
    close: function(){
      this.$emit('close')
    },
    setFormData: function(){
      this.formData = this.cardItemsForFormData
    }
  },
  mounted(){
    this.setFormData()
  }
}

</script>

